import { useCallback } from 'react';
import useAnalyticEvents from '@hooks/analytics/use-analytic-events';
import { StickyNavApiEntry } from '@interfaces/models/sticky-nav';
import { isUniverseEntryPoint } from '@helpers/utils/sticky-nav/sticky-nav-entry-point-helpers';

const useStickyNavNavigation = () => {
  const { sendAnalyticEvent } = useAnalyticEvents('navigation');

  const buildLinkHref = useCallback((entryPoint: StickyNavApiEntry): string => {
    if (!entryPoint.destination?.universalLink) {
      return '#';
    }

    try {
      // Use a fallback origin to support relative URLs and avoid relying on `window.location.origin` during SSR.
      const base = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
      const url = new URL(entryPoint.destination.universalLink, base);

      url.searchParams.set('ts', Date.now().toString());

      // Return a relative URL to keep internal links consistent.
      return `${url.pathname}${url.search}${url.hash}`;
    } catch {
      return '#';
    }
  }, []);

  const handleEntryPointClick = useCallback(
    (entryPoint: StickyNavApiEntry, clickPosition: number) => {
      const isUniverse = isUniverseEntryPoint(entryPoint);

      sendAnalyticEvent('click_sticky_navigation', {
        label: 'sticky_navigation',
        property: isUniverse ? '' : entryPoint.destination?.categoryId || '',
        value: clickPosition,
      });
    },
    [sendAnalyticEvent],
  );

  return {
    handleEntryPointClick,
    buildLinkHref,
  };
};

export default useStickyNavNavigation;
